import { FC, useContext } from "react";
import { MultiMapExportContext } from "@app/projects/network-assessment/multi-map-export/MultiMapExportContext";
import { countMaps, countSelectedAdequacyStatuses, countSelectedCounties, countSelectedProviderSources, countSelectedSpecialties, formatMapCount, pluralize } from "@app/projects/network-assessment/multi-map-export/utils/mapCountSelection";
import LoadingSpinner from "@app/shared/LoadingSpinner";

export const MapCountSection: FC<React.PropsWithChildren<unknown>> = () => {
  const { adequacyCombinations, adequacyCombinationsLoading, selections } = useContext(MultiMapExportContext);
  const countyCount = countSelectedCounties(selections);
  const specialtyCount = countSelectedSpecialties(selections);
  const adequacyStatusCount = countSelectedAdequacyStatuses(selections);
  const providerSourceCount = countSelectedProviderSources(selections);
  const mapCount = countMaps(selections, adequacyCombinations);

  if (adequacyCombinationsLoading) {
    return (
      <div className="multi-map-export__map-count" data-testid="multi-map-export__map-count">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="multi-map-export__map-count" data-testid="multi-map-export__map-count">
      <div className="multi-map-export__map-count-header">
        <span className="multi-map-export__map-count-total" data-testid="multi-map-export__map-count-total">
          {formatMapCount(mapCount)}
        </span>
        <p className="multi-map-export__map-count-label">Maps will be generated</p>
      </div>
      <p className="multi-map-export__map-count-summary" data-testid="multi-map-export__map-count-summary">
        <strong>{formatMapCount(countyCount)}</strong> {pluralize(countyCount, "county", "counties")} × <strong>{formatMapCount(specialtyCount)}</strong> {pluralize(specialtyCount, "specialty", "specialties")},
        {" "}across <strong>{formatMapCount(adequacyStatusCount)}</strong> adequacy {pluralize(adequacyStatusCount, "status", "statuses")}.
        <br />
        {" "}<strong>{formatMapCount(providerSourceCount)}</strong> provider {pluralize(providerSourceCount, "source", "sources")} overlaid.
      </p>
      <div className="multi-map-export__map-count-breakdown">
        <div className="multi-map-export__map-count-breakdown-item">
          <span className="multi-map-export__map-count-breakdown-value" data-testid="multi-map-export__map-count-counties">{formatMapCount(countyCount)}</span>
          <span className="multi-map-export__map-count-breakdown-label">Counties</span>
        </div>
        <div className="multi-map-export__map-count-breakdown-item">
          <span className="multi-map-export__map-count-breakdown-value" data-testid="multi-map-export__map-count-specialties">{formatMapCount(specialtyCount)}</span>
          <span className="multi-map-export__map-count-breakdown-label">Specialties</span>
        </div>
        <div className="multi-map-export__map-count-breakdown-item">
          <span className="multi-map-export__map-count-breakdown-value" data-testid="multi-map-export__map-count-maps">{formatMapCount(mapCount)}</span>
          <span className="multi-map-export__map-count-breakdown-label">Maps</span>
        </div>
      </div>
    </div>
  );
};

export default MapCountSection;
